import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  dialogTitle: {
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
  },
  surface: {
    inlineSize: "min(940px, 90vw)",
    maxInlineSize: "none",
    maxBlockSize: "85vh",
    overflowX: "hidden",
    boxSizing: "border-box",
    "@media (max-width: 640px)": {
      inlineSize: "100vw",
      maxBlockSize: "95vh",
      borderRadius: 0,
    },
  },
  content: {
    paddingTop: designTokens.spacing[4],
    paddingBottom: designTokens.spacing[4],
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
    blockSize: "calc(84vh - 120px)",
    overflowX: "hidden",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 640px)": {
      paddingLeft: designTokens.spacing[3],
      paddingRight: designTokens.spacing[3],
      maxBlockSize: "calc(95vh - 120px)",
    },
  },
  stickyHeader: {
    position: "sticky",
    top: 0,
    backgroundColor: designTokens.neutral.white,
    zIndex: 1,
    paddingBottom: designTokens.spacing[2],
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
  tabList: {
    marginBottom: designTokens.spacing[4],
    "& [role='tab']": {
      color: designTokens.neutral[500],
      fontWeight: designTokens.fontWeight.medium,
      fontSize: designTokens.fontSize.sm,
      ":hover": {
        color: designTokens.neutral[700],
      },
      "&::after": {
        width: "100%",
        left: 0,
        right: 0,
      },
    },
    "& [role='tab'][aria-selected='true']": {
      color: designTokens.neutral[900],
    },
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    columnGap: designTokens.spacing[4],
    marginBottom: designTokens.spacing[2],
  },
  scrollableContent: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    paddingTop: designTokens.spacing[2],
    paddingRight: designTokens.spacing[2],
    paddingBottom: designTokens.spacing[4],
    paddingLeft: designTokens.spacing[2],
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: designTokens.spacing[4],
    width: "100%",
    "@media (max-width: 900px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 640px)": {
      gridTemplateColumns: "1fr",
    },
  },
  emptyStateGrid: {
    gridColumn: "1 / -1",
  },
  loadingContainerOverride: {
    minHeight: "200px",
  },

  useCaseSection: {
    marginBottom: designTokens.spacing[6],
    "&:last-child": {
      marginBottom: 0,
    },
  },

  myPromptsInputRow: {
    padding: `${designTokens.spacing[4]} 0`,
    display: "flex",
    gap: 0,
    alignItems: "stretch",
    position: "relative",
    zIndex: 10,
  },
  myPromptsTextareaWrapper: {
    flex: 1,
  },
  myPromptsTextarea: {
    minHeight: "60px",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: "100%",
    width: "100%",
  },
  myPromptsSaveButton: {
    position: "relative",
    zIndex: 10,
    pointerEvents: "auto",
    minWidth: designTokens.spacing[12],
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  myPromptsCardOverride: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding(designTokens.spacing[3]),
    height: "100%",
    maxHeight: "200px",
    position: "relative",
    minHeight: designTokens.spacing[40],
  },
  myPromptsCardContent: {
    padding: designTokens.spacing[2],
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  myPromptsCardTitleWrapper: {
    marginBottom: designTokens.spacing[2],
  },
  myPromptsCardTitle: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  myPromptsCardDescriptionOverride: {
    marginBottom: designTokens.spacing[3],
    flex: 1,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
  },
  myPromptsCardFooter: {
    justifyContent: "space-between",
    display: "flex",
    paddingTop: designTokens.spacing[3],
    marginTop: "auto",
    ...shorthands.borderTop("1px", "solid", designTokens.neutral[100]),
    columnGap: designTokens.spacing[1],
  },
  myPromptsCardFooterLeft: {
    display: "flex",
    columnGap: designTokens.spacing[3],
    alignItems: "center",
  },
  myPromptsIconButton: {
    minWidth: designTokens.iconSize.lg,
    width: designTokens.iconSize.lg,
    height: designTokens.iconSize.lg,
    padding: "0",
  },
  deleteButton: {
    color: designTokens.semantic.error,
  },
});
